export const config = {
    apiUrl: 'https://produsource-60979.uc.r.appspot.com/',
    // apiUrl: 'http://localhost:3000',
};
